import { api } from '../index';

const BASE_PATH = '/api/internal/audit/caregivers';

export type Caregiver = {
  id: number;
  displayName: string;
  dni: string;
  searchName: string;
  formattedDni: string;
  humanCareer: string;
  workplace: string;
  workplaceAddress: string;
  serviceCompany: string;
  workdayType: string;
  flexibleWorkingHours: boolean;
}

export const caregiversApi = {
  index(companyId?: number, queryParams?: string): Promise<Array<Caregiver>> {
    let url = BASE_PATH;
    if (companyId) {
      url += `?company_id=${companyId}`;
      if (queryParams) url += `&${queryParams}`;
    }

    return api({
      method: 'get',
      url,
    }).then(response => response.data.caregivers);
  },
  update(caregiverId: number, email: string): Promise<Caregiver> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${caregiverId}`,
      data: { caregiver: { email } },
    }).then(response => response.data.caregiver);
  },
};
